import { useEffect } from 'react';

import { hasParentWithClassName } from '../utils/dom';


const useClickOutside = (elementRef, action) => {
  useEffect(() => {
    const clickOnDocumentHandler = (event) => {
      if (elementRef) {
        if (!hasParentWithClassName(event.target, elementRef.current.className)) {
          action();
        }
      }
    };
    document.addEventListener('click', clickOnDocumentHandler);

    return () => {
      document.removeEventListener('click', clickOnDocumentHandler);
    };
  }, [elementRef]);
};

export default useClickOutside;
